import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/auth/auth.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent implements OnInit {
  loginForm: UntypedFormGroup;

  // @ViewChild('f', {static: false}) loginForm: NgForm;

  constructor(
    private _router: Router,
    private _formBuilder: UntypedFormBuilder,
    private _route: ActivatedRoute,
    private _auth: AuthService,
  ) {}

  ngOnInit(): void {
    // Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    // Add 'implements OnInit' to the class.
    this.loginForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  // On submit button click
  onSubmit(): void {
    this._auth.signinUser(this.loginForm.value);

    // this.loginForm.reset();
  }
  // On Forgot password link click
  onForgotPassword(): void {
    this._router.navigate(['forgotpassword'], {
      relativeTo: this._route.parent,
    });
  }
  // On registration link click
  onRegister(): void {
    this._router.navigate(['register'], { relativeTo: this._route.parent });
  }
}
